module.exports = __webpack_public_path__ + "static/media/tour-0.e5754aaa.png";